import React, { useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';
import './timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCircleExclamation, faFilePen, faMagnifyingGlass, faPenToSquare, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { faCircleCheck, faFileLines } from '@fortawesome/free-regular-svg-icons';
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Modal } from 'react-bootstrap';
// import dayjs from "dayjs";
function SubmitTimesheet() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [errorPopup, setShowErr] = useState(true);
    const [showNotes, setShowNotes] = useState(false);
    const [showProject, setShowProject] = useState(false);
    const [showSubmit, setShowSubmit] = useState(false);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const handleCloseErrPopup = () => setShowErr(false);
    const handleShowDelete = () => setShowDelete(true);
    const handleCloseDelete = () => setShowDelete(false);
    // const handleShowErrPopup = () => setShowErr(false);
    const handleClose = () => setShow(false);
    const handleCloseSubmit = () => setShowSubmit(false);
    const handleShowSubmit = () => setShowSubmit(true);
    const handleShow = () => setShow(true);
    const handleShowProject = () => setShowProject(true);
    const handleCloseProject = () => setShowProject(false);
    const handleCloseNotes = () => setShowNotes(false);
    const handleShowNotes = () => setShowNotes(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [weekRange, setWeekRange] = useState("");

    const [rows, setRows] = useState([
        { id: 1, name: 'HR Training', inputs: Array(7).fill(''), total: '0.00' },
        { id: 2, name: 'Project A', inputs: Array(7).fill(''), total: '0.00' },
    ]);

    const [newProjectName, setNewProjectName] = useState('');
    // const [showSuggestions, setShowSuggestions] = useState(false);
    // const [activeIndex, setActiveIndex] = useState(-1);
    // const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    const handleInputChange = (rowId, index, value) => {
        const updated = rows.map(row => {
        if (row.id === rowId) {
            const inputs = [...row.inputs];
            inputs[index] = value;
            const total = inputs.reduce((acc, val) => acc + parseFloat(val || 0), 0);
            return { ...row, inputs, total: total.toFixed(2) };
        }
        return row;
        });
        setRows(updated);
    };

    // const handleSuggestionClick = (suggestion) => {
    //     // setSearchQuery(suggestion);
    //     setShowSuggestions(false);
    // };
    
    // const handleKeyDown = (e) => {
    //     if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
    //         setActiveIndex(activeIndex + 1);
    //     } else if (e.key === "ArrowUp" && activeIndex > 0) {
    //         setActiveIndex(activeIndex - 1);
    //     } else if (e.key === "Enter") {
    //         if (activeIndex >= 0) {
    //             const selected = filteredSuggestions[activeIndex];
    //             // setSearchQuery(selected.title);
    //             setShowSuggestions(false);
    //         }
    //     }
    // };
    const handleAddProject = () => {
        if (!newProjectName.trim()) return;

        const newRow = {
        id: Date.now(),
        name: newProjectName,
        inputs: Array(7).fill(''),
        total: '0.00'
        };

        setRows([...rows, newRow]);
        setNewProjectName('');
    };

    const dailyTotals = Array(7).fill(0);
    rows.forEach(row => {
        row.inputs.forEach((val, idx) => {
        dailyTotals[idx] += parseFloat(val || 0);
        });
    });

    const grandTotal = dailyTotals.reduce((acc, val) => acc + val, 0);
   
    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
        //   const day = date.day(); // 0 (Sunday) to 6 (Saturday)
        const sunday = date.startOf("week"); // Sunday
        const saturday = sunday.add(6, "day"); // Saturday

        const formattedRange = `${sunday.format("DD/MM/YYYY")} to ${saturday.format("DD/MM/YYYY")}`;
        setWeekRange(formattedRange);
        } else {
        setWeekRange("");
        }
    };
    
    const MAX_FILES = 10;
    const MAX_TOTAL_SIZE_MB = 2500;
    const MAX_FILE_SIZE_MB = 250;
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'application/pdf',
        'text/csv',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            // setError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                // setError(`Each file must be less than ${MAX_FILE_SIZE_MB} MB.`);
                return;
            }
            if (!allowedTypes.includes(file.type)) {
                // setError('Only image files (JPEG, PNG, GIF), CSV, PDF, and Word files are allowed.');
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
        const newSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            // setError(`Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`);
            return;
        }

        // setError('');
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            // setError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                // setError(`Each file must be less than ${MAX_FILE_SIZE_MB} MB.`);
                return;
            }
            if (!allowedTypes.includes(file.type)) {
                // setError('Only image files (JPEG, PNG, GIF), CSV, PDF, and Word files are allowed.');
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
        const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            // setError(`Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`);
            return;
        }

        // setError('');
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };


    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        // Reset the file input to allow the same file to be uploaded again
        fileInputRef.current.value = null;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Timesheet Management</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Management</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{ sm:6,xs: 12 }} container className="gap-3 regiter_inputs i94validateinput">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                        className="date_pickermux date_selectsheet"
                        value={selectedDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    {weekRange && <input style={{width:"max-content"}} value={weekRange} disabled />}
                    </Grid>
                    <Grid size={{ sm:6,xs: 12 }} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 my-0' onClick={handleShowDelete}>Delete</button>
                        <button className='registersendbtn1 my-0' onClick={handleShow}>Save</button>
                        <button className='registersendbtn2 my-0' onClick={handleShowSubmit}>Submit</button>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                            <th><input type='checkbox'/></th>
                            <th className='text-start'>Project / Assignment</th>
                            <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SUN<small>12/01</small></span></th>
                            <th><span className='d-flex flex-column'>MON<small>12/02</small></span></th>
                            <th><span className='d-flex flex-column'>TUE<small>12/03</small></span></th>
                            <th><span className='d-flex flex-column'>WED<small>12/04</small></span></th>
                            <th><span className='d-flex flex-column'>THU<small>12/05</small></span></th>
                            <th><span className='d-flex flex-column'>FRI<small>12/06</small></span></th>
                            <th className='blue_bgcell_sheet'><span className='d-flex flex-column'>SAT<small>12/07</small></span></th>
                            <th>TOTAL</th>
                            <th>NOTES</th>
                            <th>STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <tr>
                                <td className='text-center'><input type='checkbox'/></td>
                                <td className='text-start'>
                                    <span className='sheet_pronamepink'>HR Training 
                                        <FontAwesomeIcon className='icon_sheetproname' icon={faCircleExclamation} />
                                    </span>
                                </td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td><input /></td>
                                <td className='blue_bgcell_sheet'><input /></td>
                                <td>40.00</td>
                                <td><button className='timesheet_editbtn' onClick={handleShowNotes}><FontAwesomeIcon icon={faFilePen} /></button></td>
                                <td>
                                    <span className='rejected_timesheet'>Not Saved</span>
                                </td>
                            </tr> */}
                            {rows.map((row) => (
                                <tr key={row.id}>
                                    <td className='text-center'><input type='checkbox' /></td>

                                    <td className='text-start'>
                                    <span className='sheet_pronamepink'>
                                        {row.name}
                                        <FontAwesomeIcon className='icon_sheetproname' icon={faCircleExclamation} />
                                    </span>
                                    </td>

                                    {row.inputs.map((val, idx) => (
                                        <td key={idx} className={(idx === 0 || idx === 6) ? 'blue_bgcell_sheet' : ''}>
                                            <input
                                            type="number"
                                            value={val}
                                            onChange={(e) => handleInputChange(row.id, idx, e.target.value)}
                                            />
                                        </td>
                                    ))}

                                    <td className="total">{row.total}</td>

                                    <td>
                                    <button className='timesheet_editbtn' onClick={() => handleShowNotes(row.id)}>
                                        <FontAwesomeIcon icon={faFilePen} />
                                    </button>
                                    </td>

                                    <td>
                                    <span className='rejected_timesheet'>Not Saved</span>
                                    </td>
                                </tr>
                                ))}
                            <tr>
                            <td></td>
                            <td className="text-start">
                                <div className="d-flex search_div_sheet" style={{position:"relative"}}>
                                {/* <input
                                    type="text"
                                    placeholder="Search"
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                    onFocus={() => searchQuery && setShowSuggestions(true)}
                                /> */}
                                <input
                                    type="text"
                                    placeholder="Add Project"
                                    value={newProjectName}
                                    onChange={(e) => setNewProjectName(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleAddProject(); // Trigger search on Enter key press
                                        }
                                    }}
                                />
                                {/* {showSuggestions && (
                                    <ul className="suggestions-dropdown">
                                        {filteredSuggestions.length > 0 ? (
                                            filteredSuggestions.map((suggestion, index) => (
                                                <li
                                                    key={index}
                                                    className={index === activeIndex ? "active" : ""}
                                                    onMouseDown={() => handleSuggestionClick(suggestion.title)}
                                                >
                                                    {suggestion.title}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="no-suggestions">No results found</li>
                                        )}
                                    </ul>
                                )} */}
                                <button onClick={handleShowProject}>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                                </div>
                            </td>
                            {Array(7).fill(0).map((_, idx) => (
                                <td key={idx} className={(idx === 0 || idx === 6) ? 'blue_bgcell_sheet' : ''}>
                                <input disabled />
                                </td>
                            ))}
                            <td>0.00</td>
                            <td><button className="timesheet_editbtn" disabled><FontAwesomeIcon icon={faFilePen} /></button></td>
                            <td><span className="approved_timesheet">Saved</span></td>
                            </tr>

                            <tr>
                            <td className='text-center'></td>
                            <td className='text-start'>
                                Total
                            </td>
                            {dailyTotals.map((val, idx) => (
                                <td key={idx} className={(idx === 0 || idx === 6) ? 'blue_bgcell_sheet' : ''}>
                                {val.toFixed(2)}
                                </td>
                            ))}
                            <td className='blue_bgcell_sheet'><strong>{grandTotal.toFixed(2)}</strong></td>
                            <td></td>
                            <td></td>
                            </tr>

                            <tr>
                            <td className='text-center'></td>
                            <td className='text-start'>
                                Over Time
                            </td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td className='blue_bgcell_sheet'>0.00</td>
                            <td></td>
                            <td></td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container flexDirection="column">
                    <span className='mb-3 fw-bold'>Please upload any supporting documents before submission</span>
                    <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        className='drag_uploaders drager_modalsheet align-items-center flex-column d-flex mb-3'
                    >
                        <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            id="file-upload"
                            ref={fileInputRef} // Attach the ref here
                        />
                        <label htmlFor="file-upload">
                            Browse Files
                        </label>
                        <p className='w-100 mb-0 mt-3'>or drop file here</p>
                    </div>
                    <Grid size={{md:6,xs:12}}>
                        {files.map((file, index) => (
                            <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach bg_sheet_files">
                                <Grid size={{sm:8,xs:6}} container>
                                    <span className='filenamesshow'>{file.name}</span>
                                </Grid>
                                <Grid size={{sm:2,xs:3}} container justifyContent="flex-end">
                                    <button onClick={() => handleRemoveFile(index)}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='registersendbtn2 mb-2'>Submit</button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showNotes}
                onHide={handleCloseNotes}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container>
                    <Grid size={{xs:12}} container flexDirection="column">
                        <h4>HR Training</h4>
                        <label className='fw-semibold'>Weekly Notes</label>
                        <input className='input_sheetnotes'/>
                        <div className='w-100 daily_notesmain'>
                            <label className='fw-bold mb-2 w-100'>Daily Notes</label>
                            <Grid size={{xs:12}} container className="daily_notessheet_scroll">
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Sunday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Monday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Tuesday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Wednesday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Thursday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Friday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-wrap justify-content-between mb-3'>
                                    <div className='notes_bluemodal'>
                                        <span>Saturday</span>
                                        <span>11/01</span>
                                    </div>
                                    <div className='content_notes'>
                                        <button><FontAwesomeIcon icon={faPenToSquare} /></button>
                                        <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </span>
                                    </div>
                                </div>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleCloseNotes}>
                            Cancel
                        </button>
                        <button className='registersendbtn2 mb-2'>Submit</button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showProject}
                onHide={handleCloseProject}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <h4 className='my-0'>Projects</h4>
                </Modal.Header>
                <Modal.Body>
                <Grid size={{xs:12}} container>
                    <Grid size={{xs:12}} container className="projects_modaltimesheet">
                        <span>Test project 1</span>
                        <span>Test project 2</span>
                        <span>Test project 3</span>
                        <span>Test project 4</span>
                        <span>Test project 5</span>
                        <span>Test project 6</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn1 mb-2' onClick={handleCloseProject}>
                            Cancel
                        </button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
            <Modal
                show={showSubmit} 
                onHide={handleCloseSubmit}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                        <FontAwesomeIcon className='main_tickiconpopup mb-4' icon={faCircleCheck} />
                        <small >You have successfully submitted your time sheet</small>
                        <div className='w-100 d-flex justify-content-end'>
                            <button className='registersendbtn1 m-0 px-5' style={{width:"max-content"}} onClick={handleCloseSubmit}>
                                Close
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={errorPopup} 
                onHide={handleCloseErrPopup}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    <h4 className='mb-0'>Change date</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex w-100 flex-column modal_register">
                        <h5>Do you want to save changes before change this date?</h5>
                        <p>Your changes will be lost if you leave now.</p>
                    </div>
                    </Modal.Body>
                    <Modal.Footer>
                    <button className='blue_primarymodalbtn1' onClick={handleCloseErrPopup}>
                        Cancel
                    </button>
                    <button className='blue_primarymodalbtn2'>
                        Leave
                    </button>
                    </Modal.Footer>
                {/* <Modal.Body>
                    <div className='d-flex flex-column error_modal align-items-center'>
                        <FontAwesomeIcon className='error_icon mb-3' icon={faCircleXmark} />
                        <span>Before change the please save the time sheet</span>
                        <div className='w-100 d-flex justify-content-end'>
                            <button className='registersendbtn1 mb-0 px-5' style={{width:"max-content"}} onClick={handleCloseErrPopup}>
                                Close
                            </button>
                        </div>
                    </div>
                </Modal.Body> */}
            </Modal>
            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Timesheet?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleCloseDelete}>
                        Cancel
                    </button>
                    <button className='modal_delete' 
                    // onClick={handleDelete}
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  );
}

export default SubmitTimesheet;